import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useMutation } from "@apollo/react-hooks";
import { useHistory } from "react-router-dom";
import { Result, Button, message } from "antd";
import LoginImage from "../../Assets/Images/login.jpg";
import { VERIFY_EMAIL } from "../../Graphql/mutations";
import { Loader } from "../../Components/Loader";

export const VerifyEmailPage = ({ lastScreen }) => {
  const history = useHistory();
  const { token } = useParams();
  const user_id = localStorage.getItem("user_id");
  const [isVerified, setIsVerified] = useState(false);

  const [VERIFY_EMAIL_MUTATION, { loading: verifyEmailLoading }] =
    useMutation(VERIFY_EMAIL);

  useEffect(() => {
    verifyEmail();
  }, []);

  const verifyEmail = async () => {
    try {
      const result = await VERIFY_EMAIL_MUTATION({
        variables: {
          token: token,
        },
      });
      if (result?.errors) {
        message.error(result?.errors[0]?.message);
      } else {
        setIsVerified(true);
      }
    } catch (error) {}
  };

  return (
    <div className="rowSec">
      <div className="colSec onBoardingLeft">
        <img src={LoginImage} alt="" className="" />
      </div>
      <div className="colSec onBoardingRight emailVerified d-flex align-items-center justify-content-center">
        {!isVerified && verifyEmailLoading ? (
          <Loader />
        ) : (
          <Result
            status="success"
            title="Email Verified Successfully!"
            extra={[
              !user_id ? (
                <Button
                  shape="round"
                  size="large"
                  onClick={() => history.push("/login")}
                >
                  Login
                </Button>
              ) : (
                <Button
                  shape="round"
                  size="large"
                  onClick={() =>
                    history.push(
                      lastScreen?.getUsersById?.last_screen ||
                        "/on-boarding/business-details"
                    )
                  }
                >
                  {lastScreen?.getUsersById?.last_screen === "/"
                    ? "Go to Dashboard"
                    : "Continue"}
                </Button>
              ),
            ]}
          />
        )}
      </div>
    </div>
  );
};
